import { IAction } from "../model/IAction";

import * as AddNewEnvironmentVariableActions from "../actions/AddNewEnvironmentVariable";
import * as FetchActions from "../actions/FetchDataItems";

export function environmentVariables(state: string[] = [], action: IAction): string[] {
    switch (action.type) {
        case FetchActions.RECEIVE_ENVIRONMENT_VARIABLES:
            const receiveAction = action as FetchActions.IReceiveEnvironmentVariablesAction;
            return receiveAction.environmentVariableNames;
        case AddNewEnvironmentVariableActions.ADDED_ENVIRONMENT_VARIABLE:
            const addAction = action as AddNewEnvironmentVariableActions.AddedNewEnvironmentVariableAction;
            const updatedEnvironmentVariablesList = state.slice();
            updatedEnvironmentVariablesList.push(addAction.environmentVariableName);
            return updatedEnvironmentVariablesList;
        default:
            return state;
    }
}
